import React from "react";
import ButtonForm from "../../ButtonForm/ButtonForm";
import PropTypes from "prop-types";
import "./SubmitButton.css";

const SubmitButton = ({
  id = "",
  title = "Submit",
  disabled = false,
  ...rest
}) => {
  return (
    <ButtonForm
      type="button"
      id={id}
      disabled={disabled}
      value={title}
      className="btn-submit"
      {...rest}
    />
  );
};

SubmitButton.propTypes = {
  id: PropTypes.number,
  title: PropTypes.string,
  disabled: PropTypes.bool,
};

export default SubmitButton;
